
<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading"></txp-loading>

<txp-message
    *ngIf="thirdPartyCookiesDisabled && !isLoading"
    [type]="messageType.DANGER"
    data-qa-label="ThirdPartyCookiesErrorMessage">

    {{ 'routing.thirdPartyCookiesMessage' | translate }}
</txp-message>
<txp-message
    *ngIf="noBrandsAssigned && !isLoading"
    [type]="messageType.DANGER"
    data-qa-label="NoBrandsAssignedErrorMessage">

    {{ 'routing.noBrandsAssignedMessage' | translate }}
</txp-message>

